/**
 * True if it has advertising from the given partner.
 * Any partner if none specified.
 */
export function docHasPartnerAdvertising(doc, partner) {
  if (doc.doctype != "Propuesta") return false 
  const target = partner.publiActivity
  
  // const target = AdvertisingPartners[partnerKey].publiActivity
  const r = doc.selectedActivities.some(x => (
    x == target
  ))
  
  console.log(`For partner ${partner._id}, looking for ${target} => ${r}`)
  return r
}

export function docHasAnyAdvertising(doc, publiActivitiesSet) {
  return doc.selectedActivities.some(x => {
    console.log({ x, publiActivitiesSet })
    return publiActivitiesSet.has(x)
  })
}

// partners found in this doc (the whole partner, no id!)
export function docHasWhichAdvertising(doc, partners) {
  const found = []
  doc.selectedActivities.forEach(a => {
    partners.forEach(p => {
      if (p.publiActivity == a) {
        found.push(p)
      }
    })
  })
  return found
}

export async function tripHasPartnerAdvertising(documentedTrip, partner) {
  console.log(`tripHasPartnerAdvertising? ${JSON.stringify(partner)}`)
  return documentedTrip.documents.some(
    doc => docHasPartnerAdvertising(doc, partner)
  )
}

export async function tripHasAnyAdvertising(documentedTrip, publiActivitiesSet) {
  return documentedTrip.documents.some(
    doc => docHasAnyAdvertising(doc, publiActivitiesSet)
  )
}
